import AuthenticatedPaths from '/b2b/routing/AuthenticatedRoutes/AuthenticatedRoutes.paths';
import { DEFAULT_LOCALE } from '/b2b/common/helpers/i18n';
import { fetchLocale as FetchLocaleService } from '/b2b/common/services/locale';
import LocaleActions from '/b2b/common/state/locale/Locale.actions';

export const signOut = () => () => {
    window.location = AuthenticatedPaths.LOGOUT;
};

export const selectLocale =
    (locale = DEFAULT_LOCALE) =>
    dispatch => {
        // These async events carry meta first, so params must be the second arg
        // (mirrors App.commands.fetchLocale); otherwise the reducer never sees
        // payload.params and the selected locale's phrases are dropped.
        const meta = { noRefresh: true };
        const params = { locale };
        dispatch(LocaleActions.fetchLocaleBegin(meta, params));
        return FetchLocaleService(params)
            .then(response => dispatch(LocaleActions.fetchLocaleSuccess(meta, params, response)))
            .catch(error => dispatch(LocaleActions.fetchLocaleFailure(meta, params, error)));
    };
